import { render, staticRenderFns } from "./DIASRealEstateAgent.vue?vue&type=template&id=1524d03e&"
import script from "./DIASRealEstateAgent.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstateAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports